import React from 'react'
import './ui.css'

const VARIANTS = ['active', 'success', 'warning', 'draft', 'review']

/**
 * Статусный бейдж с точкой (новая DS).
 */
function StatusBadge ({ variant = 'draft', children, className = '' }) {
  const v = VARIANTS.includes(variant) ? variant : 'draft'
  return (
    <span className={`ds-status-badge ds-status-badge-${v} ${className}`.trim()}>
      {children}
    </span>
  )
}

export default StatusBadge
